import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import LanguageSwitcher from "@/components/LanguageSwitcher";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen flex bg-[#0B0C0E]">
      <div className="hidden lg:flex flex-col justify-between w-1/2 relative overflow-hidden grid-glow p-12 border-r border-amber-500/15">
        <div className="absolute -top-32 -left-24 h-96 w-96 rounded-full bg-amber-500/10 blur-[120px]" />
        <Logo size="lg" />
        <div className="relative">
          <h2 className="font-display text-4xl font-extrabold text-white leading-tight">Scale your digital growth with <span className="gold-text">ADNEXA DIGITAL</span></h2>
          <p className="mt-5 text-slate-400 max-w-md">Performance marketing, paid advertising and SEO — all managed from one premium dashboard.</p>
        </div>
        <p className="relative text-xs text-slate-600">© 2026 ADNEXA DIGITAL</p>
      </div>
      <div className="flex-1 flex flex-col">
        <div className="flex items-center justify-between p-6">
          <div className="lg:hidden"><Logo /></div>
          <div className="ml-auto"><LanguageSwitcher /></div>
        </div>
        <div className="flex-1 flex items-center justify-center p-6">
          <div className="w-full max-w-md">
            <h1 className="text-3xl font-extrabold text-white">{title}</h1>
            {subtitle && <p className="text-slate-400 mt-2">{subtitle}</p>}
            <div className="mt-8">{children}</div>
            {footer && <div className="mt-6 text-center text-sm text-slate-400">{footer}</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
